import styled from 'styled-components';
import { media, Column } from '@simplywallst/ui-core';

export const Container = styled(Column)`
  ${media.mdDown`
      background-color: ${({ theme }) => theme.color.noir};
      margin-bottom: ${({ theme }) => `${theme.x3spacePx}px`};
      padding-bottom: ${({ theme }) => `${theme.x3spacePx}px`};
  `}
  margin-bottom: ${({ theme }) => `${theme.x3spacePx}px`};
`;

export const SidebarWrapper = styled('div')`
  margin-left: ${({ theme }) => `${theme.x3spacePx}px`};
`;

export const Header = styled('header')`
  padding: ${({ theme }) => `${theme.x2spacePx}px ${theme.x2spacePx}px`};
  ${media.lgUp`
    padding: ${({ theme }) => `0 0 ${theme.x1spacePx}px`};
  `};
`;

export const Title = styled('h1')`
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${({ theme }) => theme.typography.megaStrong};
`;

export const MarketPerformance = styled('ul')`
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
`;

export const FixedSidebar = styled.div`
  top: ${({ theme }) => theme.x15spacePx}px;
  bottom: 0;
  position: fixed;
  /*
    desktop sidebar width = full width * sidebar desktop width percentage - padding
    max-width of sidebar = max page width * sidebar desktop percentage = 1152px * 37.5%
   */
  width: min(calc(100vw * 0.375 - 24px), 432px);
`;
